import React from 'react';

const DropdownIcon = () => {
	return (
		<svg
			data-testid='dropdown-icon'
			fill='none'
			height='5'
			viewBox='0 0 8 5'
			width='8'
		>
			<path
				d='M4 4.5L0 0.5H8L4 4.5Z'
				fill='#1F1F47'
			/>
		</svg>
	);
};

export default DropdownIcon;
